import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "./assets/scss/style.scss?v=1.2.0";
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import FrontendConfig from "./assets/config.js";

ReactDOM.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider reCaptchaKey={FrontendConfig.reCaptchaKey}>
      <App />
    </GoogleReCaptchaProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();